export const LOGIN_ROUTE = "login";
export const LOGOUT_ROUTE = "logout";
export const DASHBOARD_ROUTE = "dashboard";
export const RECOVER_ROUTE = "recover";
